import {Component} from '@angular/core';
import {DatiApiService} from '../../core/services/dati-api.service';
import {NgForm} from '@angular/forms';
import {AppComponent} from '../../app.component';

@Component({
  selector: 'app-home',
  template: `
      <h1>Covid-19 - Dati aggiornati</h1>

      <div *ngIf="api?.loading" class="mb-3">
          <div class="card" [ngClass]="{'bg-color-dark-color-white': app.backgroundColorDark}">
              <div class="card-body text-center">
                  ...CARICAMENTO IN CORSO...
                  <br>
                  <span class="text-muted">assicurarsi di aver accettato i cookie.</span>
              </div>
          </div>
      </div>

      <div class="row mx-1">
          <div class="col-0 mt-2">
              Theme:
          </div>
          <div class="col-2">
              <i *ngIf="app.backgroundColorDark" (click)="switchTheme()"
                 class="fa fa-toggle-off font-size-40 switch"></i>
              <i *ngIf="!app.backgroundColorDark" (click)="switchTheme()"
                 class="fa fa-toggle-on font-size-40 color-primary switch"></i>
          </div>
      </div>
      <br>
      <div class="card mb-4" [ngClass]="{'bg-color-dark-color-white': app.backgroundColorDark}">
          <div class="card-header">
              <p class="float-left mb-0">ITALIA</p>
              <p class="text-align-right mb-0 text-red">aggiornato al: {{api.datiApiNazionali[0]?.data|date:'dd/MM/yyyy'}}</p>
          </div>
          <div class="card-body">
              <div class="row mb-3">
                  <div class="col-md-1 font-size-40 color-blue">
                      <i class="fa fa-user"></i>
                  </div>
                  <div class="col-md-3">
                      Nuovi positivi<br>
                      <span class="font-dati-nazionali">
                          {{api.datiApiNazionali[0]?.nuovi_positivi|number}}
                      </span>
                  </div>
                  <div class="col-md-1 font-size-40 color-green">
                      <i class="fa fa-smile-o"></i>
                  </div>
                  <div class="col-md-3">
                      Dimessi guariti<br>
                      <span class="font-dati-nazionali">
                          {{api.datiApiNazionali[0]?.dimessi_guariti|number}}
                      </span>
                  </div>

                  <div class="col-md-1 font-size-40">
                      <i class="fa fa-times"></i>
                  </div>
                  <div class="col-md-3">
                      Deceduti<br>
                      <span class="font-dati-nazionali">
                          {{api.datiApiNazionali[0]?.deceduti|number}}
                      </span>
                  </div>
              </div>
              <div class="row mb-3">
                  <div class="col-md-1 font-size-40 color-yellow">
                      <i class="fa fa-home"></i>
                  </div>
                  <div class="col-md-3">
                      Isolamento domiciliare<br>
                      <span class="font-dati-nazionali">
                          {{api.datiApiNazionali[0]?.isolamento_domiciliare|number}}
                      </span>
                  </div>

                  <div class="col-md-1 font-size-40 color-red">
                      <i class="fa fa-stethoscope"></i>
                  </div>
                  <div class="col-md-3">
                      Terapia intensiva<br>
                      <span class="font-dati-nazionali">
                          {{api.datiApiNazionali[0]?.terapia_intensiva|number}}
                      </span>
                  </div>

                  <div class="col-md-1 font-size-40 color-brown">
                      <i class="fa fa-flask"></i>
                  </div>
                  <div class="col-md-3">
                      Tamponi<br>
                      <span class="font-dati-nazionali">
                          {{api.datiApiNazionali[0]?.tamponi|number}}
                      </span>
                  </div>
              </div>
              <div class="row mb-3">
                  <div class="col-md-1 font-size-40 color-magenta">
                      <i class="fa fa-medkit"></i>
                  </div>
                  <div class="col-md-3">
                      Totale positivi<br>
                      <span class="font-dati-nazionali">
                          {{api.datiApiNazionali[0]?.totale_positivi|number}}
                      </span>
                  </div>

                  <div class="col-md-1 font-size-40 color-purple">
                      <i class="fa fa-h-square"></i>
                  </div>
                  <div class="col-md-3">
                      Totale ricoverati<br>
                      <span class="font-dati-nazionali">
                          {{api.datiApiNazionali[0]?.totale_ospedalizzati|number}}
                      </span>
                  </div>

                  <div class="col-md-1 font-size-40 color-orange">
                      <i class="fa fa-folder"></i>
                  </div>
                  <div class="col-md-3">
                      Casi totali<br>

                      <span class="font-dati-nazionali">
                          {{api.datiApiNazionali[0]?.totale_casi|number}}
                      </span>
                  </div>
              </div>
          </div>
      </div>

      <div class="card mb-4" [ngClass]="{'bg-color-dark-color-white': app.backgroundColorDark}">
          <div class="card-body">
              <form #f="ngForm" (submit)="filterClick(f)">
                  <div class="row mb-2">
                      <div class="col-md-6">
                          <label for="regione">Seleziona la regione</label>
                          <select name="regione" id="regione" class="form-control" required (ngModelChange)="changeRegione($event)"
                                  [ngModel]="regioneFiltro" [ngClass]="{'input-dark': app.backgroundColorDark}">
                              <option value="0" [selected]="true">seleziona una regione</option>
                              <option *ngFor="let regione of api?.regioni" [value]="regione.codice_regione" [selected]="false">
                                  {{regione.denominazione_regione}}
                              </option>
                          </select>
                      </div>
                      <div class="col-md-6">
                          <label for="provincia">Seleziona la provincia</label>
                          <select name="provincia" id="provincia" class="form-control" required [ngModel]="provinciaFiltro"
                                  [disabled]="provinceDisabled" [ngClass]="{'input-dark': app.backgroundColorDark}">
                              <option value="0" [selected]="true">seleziona una provincia</option>
                              <option *ngFor="let province of api?.province" [value]="province.codice_provincia" [selected]="false">
                                  {{province.denominazione_provincia}}
                              </option>
                          </select>
                      </div>
                  </div>
                  <div class="float-right">
                      <button class="btn px-4"
                              [ngClass]="{'btn-secondary-dark': app.backgroundColorDark, 'btn-secondary': !app.backgroundColorDark}"
                              (click)="resetForm(f)"><i class="mr-2 fa fa-undo"
                      ></i>Reset
                      </button>
                  </div>
                  <div class="float-right">
                      <button class="btn px-4 mr-2"
                              [ngClass]="{'btn-primary-dark': app.backgroundColorDark, 'btn-primary': !app.backgroundColorDark}"
                              type="submit"><i class="mr-2 fa fa-search"></i>Cerca
                      </button>
                  </div>
              </form>
          </div>
      </div>

      <div class="card-deck">
          <div *ngFor="let dati of api?.datiApiRegionaliFilter" class="px-0 mb-3"
               [ngClass]="{'col-12 col-sm-12 col-md-6 col-lg-4': !isActivedFilter,'col-12': isActivedFilter}">
              <div class="card" [ngClass]="{'bg-color-dark-color-white': app.backgroundColorDark}">
                  <div class="card-body">
                      <h6 class="nome-regione" (click)="maps(dati.denominazione_regione)">{{dati.denominazione_regione}}</h6>
                      <p class="text-red font-weight-600">{{dati.totale_casi|number}} CASI TOTALI</p>
                      <hr>
                      <div>
                          <p class="float-left font-weight-600">Nuovi positivi</p>
                          <p class="text-align-right text-success">{{dati.nuovi_positivi|number}}</p>
                      </div>
                      <div>
                          <p class="float-left font-weight-600">Ricoverati con sintomi</p>
                          <p class="text-align-right text-success">{{dati.ricoverati_con_sintomi|number}}</p>
                      </div>
                      <div>
                          <p class="float-left font-weight-600">Terapia intensiva</p>
                          <p class="text-align-right text-success">{{dati.terapia_intensiva|number}}</p>
                      </div>
                      <div>
                          <p class="float-left font-weight-600">Isolamento domiciliare</p>
                          <p class="text-align-right text-success">{{dati.isolamento_domiciliare|number}}</p>
                      </div>
                      <div>
                          <p class="float-left font-weight-600">Tamponi</p>
                          <p class="text-align-right text-success">{{dati.tamponi|number}}</p>
                      </div>
                      <div>
                          <p class="float-left font-weight-600">Deceduti</p>
                          <p class="text-align-right text-success">{{dati.deceduti|number}}</p>
                      </div>
                      <div>
                          <p class="float-left font-weight-600">Dimessi guariti</p>
                          <p class="text-align-right text-success">{{dati.dimessi_guariti|number}}</p>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <div *ngIf="isActivedProvinciaFilter">
          <hr>
          <div class="card-deck">
              <div *ngFor="let provincia of api?.datiApiProvinceFilter" class="col-12 col-sm-12 col-md-6 col-lg-6 px-0 mb-3">
                  <div class="card" [ngClass]="{'bg-color-dark-color-white': app.backgroundColorDark}">
                      <div class="card-body">
                          <h6 class="nome-regione" (click)="maps(provincia.denominazione_provincia)">{{provincia.denominazione_provincia}}</h6>
                          <p class="text-red font-weight-600">{{provincia.totale_casi|number}} CASI TOTALI</p>
                      </div>
                  </div>
              </div>
          </div>
      </div>

  `,
  styles: []
})
export class HomeComponent {
  provinceDisabled: boolean = true;
  isActivedFilter: boolean = false;
  isActivedProvinciaFilter: boolean = false;
  regioneFiltro: number = 0;
  provinciaFiltro: number = 0;

  constructor(private api: DatiApiService, private app: AppComponent) {
    api.getDatiNazionali();
  }

  changeRegione(event) {
    this.regioneFiltro = event;
    if (this.regioneFiltro != 0) {
      this.provinceDisabled = false;
    } else {
      this.provinceDisabled = true;
    }
    this.api.getProvince(event);
  }

  filterClick(form: NgForm) {
    this.regioneFiltro = form.value.regione;
    this.provinciaFiltro = form.value.provincia;

    this.isActivedFilter = true;
    this.isActivedProvinciaFilter = true;
    this.api.filtroRegione(this.regioneFiltro);
    this.api.filtroProvincia(this.provinciaFiltro);

    if (this.regioneFiltro == 0) {
      this.isActivedFilter = false;
      this.isActivedProvinciaFilter = false;
    }
  }

  resetForm(form: NgForm) {
    this.regioneFiltro = 0;
    this.provinciaFiltro = 0;

    form.value.regione = 0;
    form.value.provincia = 0;
    this.changeRegione(form.value.regione);
  }

  switchTheme(){
    this.app.backgroundColorDark = !this.app.backgroundColorDark;
    this.app.backgroundColorDark ? document.cookie = "theme=DARK" : document.cookie = "theme=WHITE";
  }

  maps(localita) {
    window.open(`https://www.google.it/maps/place/${localita}`);
  }
}
